<template>
  <div>
  <v-card color="grey lighten-5" flat>
    <v-flex xs12 sm12>
                 <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Sorun Detay</v-toolbar-title>
              <v-spacer></v-spacer>
                 <v-btn  @click="duzenlegonder(SorunDetay.SorunID)" class="white--text" flat><span
                                class="hidden-sm-and-down">Sorun Düzenle</span>
                      <v-icon right dark>edit</v-icon>
                  </v-btn>
              <v-menu bottom="">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <a target="_self" v-bind:href="'#/destek/index/'">
                    <v-list-tile>
                      <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
    </v-flex>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex pa-1 xs12 sm12 md12>
          <v-flex xs12 sm12 md12 style="padding-right:2px;">
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md1>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">info</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md11>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              Ürün Adı
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md6>
                            <span class="caption font-weight-bold">:
                              {{SorunDetay.UrunBilgi.UrunAdi}}
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              Çözecek
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md6>
                            <span class="caption font-weight-bold">
                              : {{SorunDetay.CozecekBilgi.AdSoyad}}
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    
                    <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Alış Tarihi</div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{SorunDetay.AlisTarihi | dateformat}}
                                </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Arayan</div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md6>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{SorunDetay.Arayan}}
                               </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Süre</div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md6>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                               {{minutes}} 
                               </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                        <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Sorun Türü</div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md6>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{SorunDetay.SorunTip.Aciklama}}
                               </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                       <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Arayan Mail</div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md5>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{SorunDetay.ArayanMail}}
                              </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                       <v-flex xs12 sm12 md6>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Sorumlu Birim</div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md6>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{SorunDetay.BeklenenYer.Aciklama}}
                              </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Sorun </div>
                            </span>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                            <span class="caption font-weight-bold">
                              
                            <div class="font-weight-bold caption  white--text  mb-1"  v-html="SorunDetay.SorunAciklama">
                                
                              </div>
                            </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>   
          <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>
                <v-card v-if="destekitems == ''">
                <v-flex pa-2 xs12 sm12 md2>
                <v-layout align-center justify-start row >
                    <v-form ref="formaktarim" id="formaktarim" method="post"  v-model="valid"
                      lazy-validation>
                      <input hidden type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
                    </v-form>
                    <a target="_self" v-bind:href="'#/destek/sorundestekislem/id?' + 'sorunid=' + SorunDetay.SorunID + '&islem=ekle'">
                      <v-btn color="info" dark >
                      <v-icon color="white" left>add_box</v-icon>Destek Ekle
                      </v-btn>
                      </a>
                    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
                      <v-icon color="white" left>attach_file</v-icon>Dosya Yükle
                    </v-btn>  
                    <div v-show="load2">
                      <v-btn small="" fab ref="fab" @click="btnSubmitFiles()"
                        color="info" dark>
                        <v-icon>save</v-icon>
                      </v-btn>
                  </div>
                  </v-layout>
                </v-flex>
                <v-flex pa-2 xs12 sm12 md2>
                  <v-layout align-center="" fill-height="">
                  <div color="red"  class=" font-weight-large grey--text title ">
                  Destek Verilmemiştir
                  </div>
                  </v-layout>
                </v-flex>
                </v-card>

                <v-card v-if="destekitems != ''">
                <v-flex pa-2 xs10 sm12 md2>
                <v-layout align-center justify-start row >
                    <v-form ref="formaktarim" id="formaktarim" method="post"  v-model="valid"
                      lazy-validation>
                      <input hidden type="file" id="files" ref="files" multiple enctype="multipart/form-data" v-on:change="handleFilesUpload()" />
                    </v-form>
                    <a target="_self" v-bind:href="'#/destek/sorundestekislem/id?' + 'sorunid=' + SorunDetay.SorunID + '&islem=ekle'">
                      <v-btn color="info" dark >
                      <v-icon color="white" left>add_box</v-icon>Destek Ekle
                      </v-btn>
                      </a>
                    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
                      <v-icon color="white" left>attach_file</v-icon>Dosya Yükle
                    </v-btn>  
                    <div v-show="load2">
                      <v-btn small="" fab ref="fab" @click="btnSubmitFiles()"
                        color="info" dark>
                        <v-icon>save</v-icon>
                      </v-btn>
                  </div>
                  </v-layout>
                </v-flex>
                <v-flex pa-2  xs12 sm12 md12>
                  <v-list  two-line>
                    <template v-for="item in destekitems">
                      <v-hover v-bind:key="item.SorunID" v-slot:default="{ hover }">
                         <v-card  :elevation="hover ? 12 : 1" >
                      <v-layout  ma-2 row wrap >
                            <v-flex  xs12 sm2 md2>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Destek No: {{item.DestekID}} 
                                        </div>
                                      </v-list-tile-sub-title>  
                                        <v-list-tile-sub-title>
                                        <div class="font-weight-bold  caption">
                                          Destek Tip: {{item.DestekTip.Aciklama}}
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm3 md3>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold  caption">
                                          Çözüm Tipi:{{item.CozumTip.Aciklama}}
                                        </div>
                                      </v-list-tile-sub-title>
                                       <v-list-tile-sub-title>
                                        <div class="font-weight-bold  caption">
                                          Kullanıcı Adı:{{item.UserBilgi.AdSoyad}}
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                             <v-flex xs12 sm3 md3>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Alış Tarihi: {{item.DestekBaslangicTarih | dateformat}} 
                                        </div>
                                      </v-list-tile-sub-title>
                                       <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Saat Başlangıç: {{item.SaatBaslangic | timeformat}} 
                                        </div>
                                      </v-list-tile-sub-title>
                                       <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Saat Bitiş: {{item.SaatBitis | timeformat}} 
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                              <v-flex xs12 sm3 md3>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <v-layout>
                                          <div class="font-weight-bold caption">
                                           Sorun: 
                                          </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                      <div v-html="item.DestekAciklama.substring(0,70)" class="font-weight caption "></div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                        <v-flex xs2 sm1 md1>
                          <v-layout align-end="" justify-center="" fill-height="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout>
                                    <v-flex xs12 sm4 md5>
                                      <v-layout>
                                        <v-btn small icon class="mx-0" @click="idgonder(item.DestekID)">
                                          <v-icon color="info">edit</v-icon>
                                        </v-btn>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                       <v-spacer :key="item.id"></v-spacer>
                      </v-card>
                      </v-hover>
                    </template>
                  </v-list>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
                 <v-container>
            <v-layout justify-center="">
              <template v-if="vmodelpagination">
                <div class="text-xs-center">
                  <v-container>
                    <v-layout justify-center>
                      <v-flex xs8>
                        <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </template>
            </v-layout>
          </v-container>
  </div>
</template>
<script>
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tool from "@/components/app/coper/tools"
  import axios from 'axios'
  export default {
    data() {
      return { 
        active:'',
        expanded: [],
        minutes:'',
        saatHesaplaList:[],
        destekitems:[],
        files:[],
        valid:true,
        alertcolor: "red",
        alertmessage: 'Henüz Dosya Seçilmedi...',
        load2: false,
        load3: false,
        tooltip: false,
        loading:null,
        el: null,
        vmodelpagination:false,
        sayfalama:1,
        pagenumber:1,
        
         headers: [
          { text: 'No:', value: 'DestekID' },
          { text: 'Destek Tip', value: 'destektipaciklama' },
          { text: 'Çözüm Tip', value: 'cozumtipiaciklama' },
          { text: 'Destek', value: 'DestekAciklama' },
          { text: 'Kullanıcı Adı', value: 'UserAdSoyad' },
          { text: 'Destek Baş. Tarihi', value: 'DestekBaslangicTarih' },
          { text: 'Saat Baş.', value: 'SaatBaslangic' },
          { text: 'Saat Bit.', value: 'SaatBitis' },
          { text: 'Düzenle' },
          ],
        singleExpand: false,
       Destek:{
         Sure:null,
       },
        SorunDetay:{
        SorunID :this.$route.query.sorunid,
        MusteriBilgi :{
       MusteriID:null,
       MusteriKod:null,
       MusteriAdi:null,
        },
        UserBilgi :{
        UserID:null,
        Email:null,
        AdSoyad:null,
        },
        AlisTarihi :null,
        Arayan :null,
        ArayanMail :null,
        CozecekBilgi :{
        UserID:null,
        Email:null,
        AdSoyad:null,
        },
        Cozuldu :null,
        UrunBilgi :{
        Ref:null,
        UrunAdi:null,
        UrunAciklama:null,
        Aciklama:null,
        },
        SorunAciklama:null,
        SorunTip :{
        SorunTipID:null,
        Aciklama:null,
        },
        BaslangicSaat :null,
        BitisSaat :null,
        BeklenenYer :{
        Id:null,
        ParentId:null,
        Aciklama:null,
        Yetki:null,
        },
        UcretliDestek :null,
        UcretliDestekAciklama :null,
      },
      }
    },
    methods: {
      handleFilesUpload() {
        this.files = []
        let uploadedFiles = this.$refs.files.files;
        if (uploadedFiles.length > 0) {
          this.alertcolor = "success";
          this.alertmessage = "Toplam " + uploadedFiles.length + " adet dosya seçildi."
          this.load2 = true;
          for (var i = 0; i < uploadedFiles.length; i++) {
            this.files.push(uploadedFiles[i]);
          }
        } else {
          this.alertmessage = "Henüz Dosya Seçilmedi...";
          this.alertcolor = "red";
          this.load2 = false;
        }
    //  const input = this.$refs.file;
    //         input.type = 'text';
    //         input.type = 'file';
      },
          btnSubmitFiles() {
      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
      formData.append('files[' + i + ']', files);
      }

    formData.append('SorunID', this.$route.query.sorunid)

      axios.defaults.baseURL = auth.API_URL;
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/Calendar/FileUploadSupport',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {

          if (response.data == true) {

            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {});
    },
            removeFile(key) {
        this.files.splice(key, 1);
      },
      removeAllFiles() {
        this.$refs.confirm
          .open("Dosya Sil", "Dosyalar silinsin mi?", {
            color: "red",
          })
          .then(confirm => {
            if (confirm == true) {
              this.files = [];
            }
          });
      },
      addFiles() {
        this.$refs.files.click();
      },
      load1() {
        return (this.files.length <= 0);
      },
      idgonder(c){
       var url = '#/destek/sorundestekislem/id?' + 'supportid=' + c + '&islem=guncelle'
        window.open(url, '_blank')
      },
      duzenlegonder(e){
       var url = '#/destek/sorunislem/id?' + 'sorunid=' + e + '&islem=guncelle'
        window.open(url, '_blank')
      },
        eklegonder(a){
       var url = '#/destek/sorundestekislem/id?' + 'sorunid=' + a + '&islem=ekle'
        window.open(url, '_blank')
      },
      sorunDetaycek:sorunDetaycek,
      sorunlist:sorunlist,
      saatHesapla:saatHesapla,
    },

     beforeMount: beforeMount,
    components: {
      tarihim,
    },
     filters:{
         dateformat: function (t) {
        return helpers.dateformat(t);
         },
         timeformat: function (c) {
        return helpers.timeformat(c);
         },
        }
  }
      function saatHesapla(){
      var params = {
        ProblemID:  this.$route.query.sorunid
      }
      this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.saatHesaplaList  = response.body        
          var date1 = new Date(this.saatHesaplaList.BaslangicSaat)
          var date2 = new Date(this.saatHesaplaList.BitisSaat)
              
         
          var res = Math.abs(date1 - date2) / 1000
          var hours = Math.floor(res / 3600) % 24;    
          var last = Math.floor(res / 60) % 60
          var seconds = res % 60;
        
          if(last<9){
            this.minutes = '0' + hours + ' : '  + '0' +last + ' : ' + seconds
          }else{
          this.minutes = '0' + hours + ' : '  + last + ' : ' + seconds
          }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    }
  
  function beforeMount(){
  
     this.sorunDetaycek()
     this.sorunlist()
     this.saatHesapla()
     
  }

    function sorunlist(){
      var userparams = {
        SorunID:this.$route.query.sorunid,
        UserID:null,
        BaslangicTarih:null,
        BitisTarih:null,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportList', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.destekitems = response.body
      this.progress= false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-CustomerAllList'
        this.snackbar = true
        this.progress= false
      } else {
        this.text1 = 'Service Unavailable-CustomerAllList'
        this.snackbar = true
        this.progress= false
      }
    })
    }
  function sorunDetaycek() {
          var params = {
        ProblemID:  this.$route.query.sorunid
      }
      this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SorunDetay = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    
  }
</script>

<style>
</style>